import {store} from "@davstack/store";
import {IChurch, ICountry, IEmirate, IFather, IUser, IWorkingField} from "../types";

export const createCSStore = (storeName: string) => (store({}, {name: storeName, devtools: {enabled: true}}))

type UserStoreType = {
  loading: boolean;
  user: IUser | undefined;
}
export const userStore = createCSStore("UserStore")
  .state<UserStoreType>({loading: false, user: undefined})
  // .effects((store) => ({
  //   logChanges: () => store.onChange(console.log),
  // }));

type AppInfoStoreType = {
  churches: Record<string, IChurch>;
  countries: Record<string, ICountry>;
  emirates: Record<string, IEmirate>;
  fathers: Record<string, IFather>;
  workingFields: Record<string, IWorkingField>;
}

export const appInfoStore = createCSStore("AppInfoStore")
  .state<AppInfoStoreType>({
    churches: {},
    countries: {},
    emirates: {},
    fathers: {},
    workingFields: {}
  })
